module.exports = __webpack_public_path__ + "media/images/hackerrank/backend-27edfd968117f8decab41f55a394fd32.png";